module.exports = __webpack_public_path__ + "img/banner1.b766019e.png";